import { computed } from 'vue'

import { TaskEntry, TaskNotify, TaskStatus, TaskType, TransactionError } from '@types'

import { TRANSACTION_FIELD } from '@/const'

import { isDate, stringToLocalDateString } from '@/helpers/dates'

import { useTasksStore } from '@/store/tasks'
import { useTransactionsStore } from '@/store/transactions'
import { useTransactionsBunchStore } from '@/store/transactions/bunch'

export const useAppNotifications = () => {

  const tasksStore = useTasksStore()
  const transactionsStore = useTransactionsStore()
  const transactionsBunchStore = useTransactionsBunchStore()

  const errors = computed(() => {
    if (!transactionsStore.initFlag) return []
    return (
      transactionsStore.getErrors?.reduce(
        (calc: TaskNotify[], item: TransactionError) => {
          const entries = item.errors?.entries
          if (entries) {
            const instance = transactionsBunchStore.getElementById(item.id)
            Object.values(entries).forEach(entry => {
              Object.values(entry).forEach(message => {
                calc.push({
                  id: item.id,
                  date: instance.field<string>(TRANSACTION_FIELD.DATE)?.value,
                  status: instance.field<string>(TRANSACTION_FIELD.TYPE)?.value,
                  message: isDate(message)
                    ? `${stringToLocalDateString(message)}`
                    : message,
                })
              })
            })
          }
          return calc
        },
        [],
      ) || []
    )
  })

  const notifies = computed(() => tasksStore.getFinished.filter(filterNotify).map(prepareNotify))

  const hasUnread = computed(() => errors.value?.length || notifies.value?.length)

  const parseError = (task: TaskEntry<any>) => {
    if (task.type === TaskType.SYNC_HOLDING_ACCOUNT && task.linked_type) {
      return `Linked Account sync for ${task.linked_type}`
    }
    return task.error
  }
  
  const prepareNotifyMessage = (task: TaskEntry<any>) => {
    return task.meta_data?.deletedAccounts || parseError(task) || ''
  }
  
  const filterNotify = (task: TaskEntry<any>) => {
    return (
      task.status !== TaskStatus.SUCCEEDED &&
    ![TaskType.EOD_SEARCH, TaskType.ANALYTICS_COMPUTE].includes(task.type)
    )
  }
  
  const prepareNotify = (task: TaskEntry<any>): TaskNotify => ({
    id: task.id,
    datetime: task.created_at,
    message: prepareNotifyMessage(task),
    status: task.status,
    error: task.error || undefined,
  })

  return {
    errors,
    notifies,
    hasUnread,
  }
}
